import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: 'bulls-pay-success-page.component.html',
  styleUrls: ['bulls-pay-success-page.component.scss'],
  selector: 'fgb-ecash-failure',
})
export class BullsPaySuccessPageComponent implements OnInit {
  ngOnInit() {}
}
